import { safeDecodeURIComponent } from "utils/urls";

/**
 * Encodes an API key ID for use in URLs.
 * This is necessary for OIDC keys that contain URLs with special characters (e.g., oidc::https://audience::id)
 */
export const encodeApiKeyId = (id: string): string => {
  return encodeURIComponent(id);
};

/**
 * Decodes an API key ID from URL parameters.
 * This is necessary for OIDC keys that contain URLs with special characters.
 */
export const decodeApiKeyId = (encodedId: string) => {
  return safeDecodeURIComponent(encodedId);
};
